export default __webpack_public_path__ + "static/media/protection@3x.fe291889.png";